<template>
  <div>
    <v-app-bar
      id="home-app-bar"
      app
      color="white"
      elevation="1"
      height="80"
    >
      <!-- <base-img
        :src="require('@/assets/logo.svg')"
        class="mr-3 hidden-xs-only"
        contain
        max-width="52"
        width="100%"
      /> -->

      <base-img
        :src="require('@/assets/logo-fondIndePresse.svg')"
        contain
        max-width="200"
        width="100%"
        
      />

      <v-spacer />

      <div>
        <v-tabs
          class="hidden-sm-and-down"
          optional
        >
          <v-tab
            v-for="(item, i) in items"
            :key="i"
            :to="item.to"
            :exact="item.name === 'Home'"
            :ripple="false"
            active-class="text--primary"
            :class="item.style || 'font-weight-bold'"
            min-width="96"
            text
          >
            {{ item.text }}
          </v-tab>
        </v-tabs>
      </div>

      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click="drawer = !drawer"
      />
    </v-app-bar>

    <home-drawer
      v-model="drawer"
      :items="items"
    />
  </div>
</template>

<script>
  export default {
    name: 'HomeAppBar',

    components: {
      HomeDrawer: () => import('./Drawer'),
    },

    data: () => ({
      drawer: null,
      items: [
        { name: 'home', text: 'Accueil', to: '/' },
        { name: 'About', text: 'Qui sommes-nous ?', to: '/about' },
        { name: 'Pro', text: 'Missions', to: '/mission' },
        { name: 'Pro', text: 'Actualité', to: '/actu' },
        { name: 'HoContacte', text: 'Nous contacter', to: '/contact-us' },
        { name: 'soutenir', text: 'Soutenir le FIP', to: '/soutenir', style: 'soutenir-btn font-weight-bold' },
      ],
    }),
  }
</script>

<style lang="sass">
  #home-app-bar
    .v-tabs-slider
      max-width: 24px
      margin: 0 auto

    .v-tab
      &::before
        display: none

    .soutenir-btn
      background-color: #ffab00 !important
      color: #ffffff !important
      opacity: 1 !important
      margin-left: 16px
      
      &.v-tab--active
        color: #ffffff !important
        
      &:hover
        background-color: #e59900 !important
        color: #ffffff !important
</style>
